import * as N from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as t } from "../../utilities/transformations.js";
import { distort as V } from "../../helpers/distort.js";
import { grain as W } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as x } from "../../utilities/uv.js";
const q = {
  name: "Synthesis1",
  collection: "synthesis",
  tags: ["wave", "gradient"],
  props: {
    colorA: {
      type: String,
      default: "#16b8cc",
      transform: t,
      description: "The left color of the first wave"
    },
    colorB: {
      type: String,
      default: "#5302ff",
      transform: t,
      description: "The right color of the first wave"
    },
    colorC: {
      type: String,
      default: "#ff3366",
      transform: t,
      description: "The left color of the second wave"
    },
    colorD: {
      type: String,
      default: "#ff9900",
      transform: t,
      description: "The right color of the second wave"
    },
    backgroundColor: {
      type: String,
      default: "#0a1029",
      transform: t,
      description: "The background color"
    },
    frequency: {
      type: Number,
      default: 1,
      description: "The frequency of the waves"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    },
    amplitude: {
      type: Number,
      default: 0.07,
      description: "The amplitude of the waves"
    },
    smoothness: {
      type: Number,
      default: 0.2,
      description: "How soft the edges of the waves are"
    }
  },
  fragmentNode: (e) => {
    const {
      vec4: p,
      uv: h,
      time: n,
      sin: s,
      mix: r,
      abs: a,
      smoothstep: c,
      add: d
    } = N, i = 0.05, l = 0.03, m = 1.2, g = 4, y = 0, o = V(h(), 0.08, 1, 3), _ = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform))
    ).mul(e.amplitude.uniform).add(0.5).sub(i), b = s(
      o.x.mul(e.frequency.uniform).mul(Math.PI * 2).add(n.mul(e.speed.uniform).add(g))
    ).mul(e.amplitude.uniform).add(0.5).sub(i).add(y), v = r(
      e.colorA.uniform,
      e.colorB.uniform,
      o.x
    ), T = r(
      e.colorC.uniform,
      e.colorD.uniform,
      o.x
    ), w = a(o.y.sub(_)).add(o.y.mul(l)), E = a(o.y.sub(b)).add(o.y.mul(l)), f = c(
      e.smoothness.uniform,
      0,
      w
    ), u = c(
      e.smoothness.uniform,
      0,
      E
    ), { correctedUV: C } = x(), S = W(0.8)(C), A = d(
      v.mul(f),
      T.mul(u)
    ).mul(m).sub(S.mul(m));
    return p(
      r(
        e.backgroundColor.uniform,
        A,
        d(f, u).min(1)
      ),
      1
    );
  }
};
export {
  q as componentDefinition,
  q as default
};
